import React from 'react'
import { withTranslation } from 'react-i18next'
import StepThreeForm from './StepThreeForm'
import LinkItem from 'components/Link'

const StepThree = ({t}) => {
  return (
    <div className="w-full">
      <StepThreeForm />

      <p className="text-secondary text-sm mt-4">
        {t('registration.step_three.consent.1') }
        <LinkItem 
          url=""
          tag={() => <span className="text-primary font-medium">{t('registration.step_three.consent.2')}</span>}
        />
        {t('registration.step_three.consent.3') }
        <LinkItem 
          url=""
          tag={() => <span className="text-primary font-medium">{t('registration.step_three.consent.4')}</span>}
        />
      </p>
    </div>
  )
}

export default withTranslation()(StepThree)